import Vue from 'vue'  
import App from './App.vue'
import './assets/fonts/font.css'
import Vant from 'vant';  
import 'vant/lib/index.css';  
import VueRouter from 'vue-router';  
import InvitationConfiguration from './components/InvitationConfiguration.vue';  
import RestaurantConfiguration from './components/RestaurantConfiguration.vue';
import inviteLink from './components/inviteLink.vue';
import BaiduMap from 'vue-baidu-map';

import PocketBase from "pocketbase";
Vue.prototype.$baseUrl = new PocketBase("https://kit.jichedi.net")
Vue.prototype.$globalData = {  
  img: []  
};
Vue.use(BaiduMap, {
  ak: 'F7AzO5HPX7YEHOfqWtk77GhSoFgzcHLm'
})
  
// 安装插件  
Vue.use(Vant);  
Vue.use(VueRouter);  
  
// 定义路由规则  
const routes = [  
  { path: '/', redirect: '/invitation' },
  { path: '/invitation', component: InvitationConfiguration },
  { path: '/restaurant', component: RestaurantConfiguration },
  { path: '/invite', component: inviteLink },
];  
  
// 创建路由实例  
const router = new VueRouter({  
  routes, 
});  
  
Vue.config.productionTip = false;  
  
new Vue({  
  router,  
  render: h => h(App),  
}).$mount('#app');